module.exports = __webpack_public_path__ + "static/media/Nursery_6.6484899e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/nursery/Nursery_6.png
// module id = 1285
// module chunks = 3